import { render } from "./score.vue?vue&type=template&id=7586b1a2&scoped=true"
import script from "./score.vue?vue&type=script&lang=js"
export * from "./score.vue?vue&type=script&lang=js"

import "./score.vue?vue&type=style&index=0&id=7586b1a2&scoped=true&lang=less"
import "./score.vue?vue&type=style&index=1&id=7586b1a2&lang=css"

import exportComponent from "D:\\CODE\\clpgaAppDevnew\\clpga_html\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7586b1a2"]])

export default __exports__